import { doClientRequest } from './core/ErplyAPI';

export const getProductUnits = () =>
  doClientRequest({
    request: 'getProductUnits',
  });
